<template>
  <form @submit.prevent="onsubmit()">
    <va-input
      v-model="email"
      type="email"
      :label="$t('auth.email')"
      :error="!!emailErrors.length"
      :error-messages="emailErrors"
    />

    <va-input
      v-model="password"
      type="password"
      :label="$t('auth.password')"
      :error="!!passwordErrors.length"
      :error-messages="passwordErrors"
    />

    <va-input
      v-model="nickname"
      label="昵称"
      :error="!!nicknameErrors.length"
      :error-messages="nicknameErrors"
    />

    <div class="d-flex justify--center mt-3">
      <va-button type="submit" class="my-0">注册</va-button>
    </div>
  </form>
</template>

<script>

import authApi from '../../../api/auth'

export default {
  name: 'signup',
  data () {
    return {
      email: '',
      password: '',
      nickname: '',
      agreedToTerms: false,
      emailErrors: [],
      passwordErrors: [],
      nicknameErrors: [],
    }
  },
  methods: {
    onsubmit () {
      this.emailErrors = this.email ? [] : ['Email is required']
      this.passwordErrors = this.password ? [] : ['Password is required']
      this.nicknameErrors = this.nickname ? [] : ['Nickname is required']
      if (!this.formReady) {
        return
      }
      authApi.signup({
        email: this.email,
        password: this.password,
        nickname: this.nickname,
      }).then(() => {
        this.showToast('注册成功, 请登录', {
          duration: 2000,
          icon: 'hand-o-left',
          position: 'top-center',
          fullWidth: false,
        })
        this.$router.push({ name: 'login' })
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    },
  },
  computed: {
    formReady () {
      return !(this.emailErrors.length || this.passwordErrors.length || this.nicknameErrors.length)
    },
  },
}
</script>

<style lang="scss">
</style>
